import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { IconButton, ListItem, ListItemIcon, ListItemText, Skeleton, Stack } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import {
  SpanWithEllipsisAndTooltipOnOverflow,
  api,
  getQueryProps,
  isTruthy,
  parseError,
} from 'common';

import { useReactFlowViewContext } from '../../../../context/context';

interface KnowledgeBaseFileSelectedProps {
  knowledgeBaseFileId: string;
  onRemove: (id: string) => void;
}

export function KnowledgeBaseFileSelected(props: KnowledgeBaseFileSelectedProps) {
  const { knowledgeBaseFileId, onRemove } = props;
  const { isEditable } = useReactFlowViewContext();
  const {
    data: knowledgeBaseFile,
    error,
    isPending,
    isError,
  } = useQuery({
    ...getQueryProps(api.client.KnowledgeBaseFile, 'findOneById', knowledgeBaseFileId),
    enabled: isTruthy(knowledgeBaseFileId),
  });

  return (
    <ListItem
      secondaryAction={
        <IconButton
          onClick={() => onRemove(knowledgeBaseFileId)}
          disabled={isError || !isEditable}
          edge="end"
          aria-label="delete"
          size="small"
        >
          <DeleteOutlineIcon />
        </IconButton>
      }
    >
      <ListItemText>
        {isPending ? (
          <Skeleton variant="text" />
        ) : (
          <Stack direction="row">
            <ListItemIcon>
              <InsertDriveFileOutlinedIcon />
            </ListItemIcon>
            <SpanWithEllipsisAndTooltipOnOverflow placement="left">
              {isError ? parseError(error) : knowledgeBaseFile?.name}
            </SpanWithEllipsisAndTooltipOnOverflow>
          </Stack>
        )}
      </ListItemText>
    </ListItem>
  );
}
